export default "__VITE_ASSET__DRAxEO1P__"